







import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';

const ReportingRoot = mixins(LocationBasedMixin).extend({
    data() {
        return {
            testVal: ''
        };
    }
});

export default ReportingRoot;
